import { useState, useEffect } from "react";
import { useCommonListWrap } from "../../../hooks/useCommonList/useCommonListWrap";
import { CommonListType } from "../../../hooks/useCommonList/useCommonListWrap";
import { PriceDetail } from "../../../../models/Order";
import { getListOrder, getListOrderAdmin, getListOrderPartner } from "../../../../services/OrderService";
import User, { UserRole } from "../../../../models/User";
import { CommonParamsType } from "../../../hooks/useCommonList/commonHelper";
import { getListUserService } from "../../../../services/UserService";

export default function useListUser(props?: CommonListType, prop?: { user?: User | null }) {
	const [listUser, setListUser] = useState<User[]>([]);
	const [count, setCount] = useState(0);
	const loadListOrder = async (inPage: number, inPerPage: number, phone?: string, email?: string) => {
		props?.onBeginLoad?.();
		try {
			const res = await getListUserService(
				inPage,
				inPerPage,
				phone,
				email,
				props?.filterBanned || undefined
			);

			const data = res.data;
			setListUser(data);
			setCount(res.count);
		} catch {
			setListUser([]);
		} finally {
			props?.onEndLoad?.();
		}
	};
	const reload = () => {
		loadListOrder(
			props?.page || 1,
			props?.perPage || 50,
			props?.filterPhone || "",
			props?.filterKeyword || undefined,
			props?.filterBanned || undefined
		);
	};
	useEffect(() => {
		reload();
	}, [props?.page, props?.perPage, props?.filterPhone, props?.filterKeyword, props?.filterBanned]);
	return {
		listUser,
		reload,
		count,
	};
}

export const getListUser = (prop: { user?: User | null }) => {
	const hookResult = (props: CommonListType) => useListUser(props, prop);
	return useCommonListWrap(50, hookResult);
};
